import apiCall from '../../index'

const apiService = '/api-erpunigas/api/v1/comercial/dashboard'
const authorization = 'Authorization'
const tipoToken = 'Bearer'

const service = {
  getDashboard(params) {
    const query = `?from=${params.from}`
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
